import React from "react";

export default function TermsAndService() {
  return (
    <div className=" p-6 text-gray-800 leading-relaxed">
      <h1 className="text-3xl font-bold mb-6 text-center">Terms of Service</h1>

      <p className="mb-4">
        Welcome to <strong>Mariniz.com</strong>. By accessing or using our website, services, or any associated
        platforms, you agree to comply with and be bound by these Terms of Service (“Terms”). Please read them carefully.
        If you do not agree, you should not use our website.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">1. About Us</h2>
      <p className="mb-4">
        Mariniz.com is a professional ship brokerage and charter marketplace based in Dubai, UAE. We connect buyers,
        sellers, and charterers of commercial vessels, including but not limited to tankers, cargo ships, ferries, and
        marine equipment.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">2. Eligibility</h2>
      <ul className="list-disc list-inside mb-4">
        <li>You are at least 18 years old.</li>
        <li>You have the legal authority to enter into binding agreements.</li>
        <li>You are not barred from using our services under applicable laws.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-2">3. Services Provided</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Ship Listings: Display of vessels for sale, purchase, and charter.</li>
        <li>Brokerage Services: Assisting in negotiations and transactions between parties.</li>
        <li>Marine Equipment Supply: Listings for marine-related equipment and services.</li>
        <li>Information Access: Providing market updates, ship particulars, and related content.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-2">4. User Responsibilities</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Provide accurate, current, and complete information.</li>
        <li>Not misrepresent ship details, ownership, or documentation.</li>
        <li>Use the platform only for lawful purposes.</li>
        <li>Not upload viruses, spam, or malicious content.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-2">5. Listing Terms</h2>
      <ul className="list-disc list-inside mb-4">
        <li>All ship and cargo listings must include truthful details.</li>
        <li>Mariniz.com reserves the right to verify, approve, or reject any listing.</li>
        <li>Listings may be removed if they violate these Terms or applicable laws.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-2">6. Brokerage Disclaimer</h2>
      <p className="mb-4">
        Mariniz.com acts as a facilitator and does not own or operate the listed vessels. We are not responsible for the
        accuracy of third-party information provided. Any agreements, payments, or disputes between users remain solely
        between the involved parties. Users are encouraged to conduct due diligence before entering into any contract.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">7. Fees & Payments</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Certain services may require payment (e.g., premium listings, advertisements, or brokerage fees).</li>
        <li>Fees will be clearly displayed before purchase.</li>
        <li>All payments are non-refundable unless otherwise stated in writing.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-2">8. Intellectual Property</h2>
      <p className="mb-4">
        All content on Mariniz.com (logo, text, design, graphics) is owned by Mariniz or its licensors. You may not
        copy, reproduce, or use our intellectual property without prior written consent.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">9. Limitation of Liability</h2>
      <p className="mb-4">
        Mariniz.com is not liable for direct, indirect, incidental, or consequential damages arising from the use of our
        services. We do not guarantee uninterrupted or error-free access to the website. We disclaim liability for
        losses caused by fraudulent listings or user misrepresentation.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">10. Indemnification</h2>
      <p className="mb-4">
        You agree to indemnify and hold harmless Mariniz.com, its directors, employees, and partners from any claims,
        damages, or expenses arising out of your use of our services or violation of these Terms.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">11. Termination</h2>
      <p className="mb-4">
        We may suspend or terminate your account and access to our services if you:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>Provide false information.</li>
        <li>Violate these Terms or applicable laws.</li>
        <li>Engage in fraudulent or harmful activity.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-2">12. Governing Law & Jurisdiction</h2>
      <p className="mb-4">
        These Terms are governed by the laws of the United Arab Emirates. Any disputes will be subject to the exclusive
        jurisdiction of the courts in Dubai, UAE.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">13. Changes to Terms</h2>
      <p className="mb-4">
        Mariniz.com reserves the right to update or modify these Terms at any time. Changes will be posted on this page
        with a revised effective date.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">14. Contact Us</h2>
      <p className="mb-4">
        <strong>Mariniz.com</strong> <br />
        302, Al Ansari Building, Dubai, UAE <br />
        📧 Email: <a href="mailto:info@mariniz.com" className="text-blue-600 underline">info@mariniz.com</a> <br />
        📞 Phone: <a href="tel:+971503505898" className="text-blue-600 underline">+971 50 350 5898</a>
      </p>
    </div>
  );
}
